import { Component, OnInit } from '@angular/core';
import { firstValueFrom, lastValueFrom, ReplaySubject } from 'rxjs';
import { AdminDataCreateDto } from 'src/app/shared/dtos/admindata/adminDataCreateDto';
import { AdminDataUpdateDto } from 'src/app/shared/dtos/admindata/adminDataUpdateDto';
import { ContactCreateDto } from 'src/app/shared/dtos/contact/contactCreateDto';
import { ContactUpdateDto } from 'src/app/shared/dtos/contact/contactUpdateDto';
import { SmsAccountCreateDto } from 'src/app/shared/dtos/smsAccount/smsAccountCreateDto';
import { SmsAccountUpdateDto } from 'src/app/shared/dtos/smsAccount/smsAccountUpdateDto';
import { SmsTemplateCreateDto } from 'src/app/shared/dtos/smsTemplate/smsTemplateCreateDto';
import { SmsTemplateUpdateDto } from 'src/app/shared/dtos/smsTemplate/smsTemplateUpdateDto';
import { SmtpCreateDto } from 'src/app/shared/dtos/smtp/smtpCreateDto';
import { SmtpUpdateDto } from 'src/app/shared/dtos/smtp/smtpUpdateDto';
import { UserCreateDto } from 'src/app/shared/dtos/user/userCreateDto';
import { AdminDataType } from 'src/app/shared/enums/adminDataType';
import { DefinationService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { BankService } from 'src/app/shared/services/bank.service';
import { BankDto } from 'src/app/shared/dtos/bankDto';
@Component({
  selector: 'app-defination',
  templateUrl: './defination.component.html',
  styleUrls: ['./defination.component.scss'],
})
export class DefinationComponent implements OnInit {

  rules = { X: /[02-9]/ };
  mask = "(X00) 000-0000";

  bankAccounts: BankDto[] = [];

  constructor(private definationService: DefinationService,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private bankService : BankService,
  ) { }

  adminDatas: any;
  contacts: any;
  smsAccounts: any;
  smsTemplates: any;
  smtps: any;
  siteLogoDto: AdminDataUpdateDto = {
    id: 0,
    name: 'SiteLogo',
    description: '',
    dataType: AdminDataType.SiteLogo
  }
  sliderImageDto: AdminDataUpdateDto = {
    id: 0,
    name: 'Slider',
    description: '',
    dataType: AdminDataType.Slider
  }

  editorOptions: any = {
    height: 500,
    toolbar: {
      items: [
        'undo', 'redo', 'separator', 'bold', 'italic', 'strike', 'underline', 'alignLeft', 'separator', 'alignLeft',
        'alignCenter', 'alignRight', 'alignJustify', 'orderedList', 'bulletList', 'separator',
        {
          name: 'size',
          acceptedValues: ['6pt', '8pt', '9pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt', '45pt'],
          options: { inputAttr: { 'aria-label': 'Font size' } }
        },
        {
          name: 'size',
          acceptedValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana', '36pt', '45pt'],
          options: { inputAttr: { 'aria-label': 'Font' } }
        },
        {
          name: 'header',
          acceptedValues: [false, 1, 2, 3, 4, 5, 6],
          options: { inputAttr: { 'aria-label': 'Header' } }
        },
        {
          name: 'link',
        },

      ]
    }
  }
  ngOnInit(): void {
    this.getList();
    this.getBankAccounts();
  }

  getList() {
    this.definationService
      .getListAdminData()
      .subscribe((data) => {
        this.adminDatas = data
        this.showLogo(this.adminDatas)
        this.showSlider(this.adminDatas)
      });
    this.definationService
      .getListContact()
      .subscribe((data) => (this.contacts = data));
    this.definationService
      .getListSmsAccount()
      .subscribe((data) => (this.smsAccounts = data));
    this.definationService
      .getListSmsTemplate()
      .subscribe((data) => (this.smsTemplates = data));
    this.definationService
      .getListSmtp()
      .subscribe((data) => (this.smtps = data));
  }

  onFileSelectedLogo(base64: any) {
    this.siteLogoDto.description = base64
  }
  onFileSelectedSlider(base64: any) {
    this.sliderImageDto.description = base64
  }
  async saveLogo() {
    this.loadingService.show()
    if (this.siteLogoDto.id > 0)
      await lastValueFrom(this.definationService.updateAdminData(this.siteLogoDto.id, this.siteLogoDto))
    else
      await lastValueFrom(this.definationService.createAdminData(this.siteLogoDto))
    this.getList();
    this.notificationService.show('Logo başarı ile yüklendi.');
    this.loadingService.hide()
  }
  async saveSlider() {
    this.loadingService.show()
    if (this.sliderImageDto.id > 0)
      await lastValueFrom(this.definationService.updateAdminData(this.sliderImageDto.id, this.sliderImageDto))
    else
      await lastValueFrom(this.definationService.createAdminData(this.sliderImageDto))
    
    this.getList();
    this.notificationService.show('Resim başarı ile yüklendi.');
    this.loadingService.hide()
  }
  showLogo(adminDatas: AdminDataUpdateDto[]) {
    let siteLogoDto = adminDatas.find(f => f.name == 'SiteLogo' && f.dataType == AdminDataType.SiteLogo)
    if (siteLogoDto)
      this.siteLogoDto = siteLogoDto
  }
  showSlider(adminDatas: AdminDataUpdateDto[]) {
    let sliderImageDto = adminDatas.find(f => f.name == 'Slider' && f.dataType == AdminDataType.Slider)
    if (sliderImageDto)
      this.sliderImageDto = sliderImageDto
  }
  async createAdminData(event: any) {
    this.loadingService.show()
    var adminDataCreateDto: AdminDataCreateDto = {
      name: event.data.name,
      description: event.data.description,
      dataType: AdminDataType.Api
    }
    await  firstValueFrom(this.definationService.createAdminData(adminDataCreateDto))
    
    this.getList();
    this.notificationService.show('Başarı ile kaydedildi.');
    this.loadingService.hide()
  }
  async updateAdminData(event: any) {
  if(event.oldData.name == "Percentage"){
    event.newData.description = event.newData.description.replace(",",".")
    if(event.newData.description && isNaN(Number(event.newData.description))){
      this.notificationService.showError('Oran için girilen değer sayı olmalıdır');
      return
    }
  }
  
  if(event.oldData.name == "MinYear"){
    event.newData.description = event.newData.description.replace(",",".")
    if(event.newData.description && isNaN(Number(event.newData.description))){
      this.notificationService.showError('Yıl için girilen değer sayı olmalıdır');
      return
    }
    
    if(Number(event.newData.description) >= (new Date()).getFullYear()){
      this.notificationService.showError(`${(new Date()).getFullYear()} yılından küçük bir değer giriniz`);
      return
    }
  }

  if(event.oldData.name == "SiteTitle" && event.newData.description.length>60){
    this.notificationService.showError('Site Title için max 60 karakter girmelisiniz');
    return
  }

  if(event.oldData.name == "MetaKeyword" && event.newData.description.length>250){
      this.notificationService.showError('Meta Keyword için max 250 karakter girmelisiniz');
      return
  }

  if(event.oldData.name == "MetaDescription" && event.newData.description.length>160){
    this.notificationService.showError('Site Title için max 160 karakter girmelisiniz');
    return
  }

    this.loadingService.show()
    if (event.newData) {
      var adminDataUpdateDto: AdminDataUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        dataType: event.oldData.dataType,
        description: event.newData.description
      }
      await firstValueFrom(this.definationService.updateAdminData(adminDataUpdateDto.id, adminDataUpdateDto))
      
      this.getList();
      this.notificationService.show('Başarı ile güncellendi.');
    }
    this.loadingService.hide()
  }
  async deleteAdminData(event: any) {
    this.loadingService.show()
    await firstValueFrom(this.definationService.deleteAdminData(event.key))
    
    this.getList();
    this.notificationService.show('Başarı ile silindi.');
    this.loadingService.hide()
  }

  async createContact(event: any) {
    this.loadingService.show()
    var contactCreateDto: ContactCreateDto = {
      title: event.data.title,
      address: event.data.address,
      phone: event.data.phone,
      whatsapp: event.data.whatsapp ?? '',
      email: event.data.email ?? '',
      mernisNo: event.data.mernisNo ?? '',
      taxNumber: event.data.taxNumber ?? '',
      companyName : event.data.companyName ?? '',
      locationLink: event.data.locationLink ?? '',
      metaKeyword: event.data.metaKeyword ?? '',
      metaDescription: event.data.metaDescription ?? ''
    }
    await firstValueFrom(this.definationService.createContact(contactCreateDto))
    
    this.getList();
    this.notificationService.show('Başarı ile kaydedildi.');
    this.loadingService.hide()
  }
  async updateContact(event: any) {
    this.loadingService.show()
    if (event.newData) {
      var contactUpdateDto: ContactUpdateDto = {
        id: event.oldData.id,
        title: event.newData.title ?? event.oldData.title,
        address: event.newData.address ?? event.oldData.address,
        phone: event.newData.phone ?? event.oldData.phone,
        whatsapp: event.newData.whatsapp ?? event.oldData.whatsapp,
        email: event.newData.email ?? event.oldData.email,
        mernisNo: event.newData.mernisNo ?? event.oldData.mernisNo,
        taxNumber: event.newData.taxNumber ?? event.oldData.taxNumber,
        companyName: event.newData.companyName ?? event.oldData.companyName,
        locationLink: event.newData.locationLink ?? event.oldData.locationLink,
        metaKeyword: event.newData.metaKeyword ?? event.oldData.metaKeyword,
        metaDescription: event.newData.metaDescription ?? event.oldData.metaDescription
      }
      await firstValueFrom(this.definationService.updateContact(contactUpdateDto.id, contactUpdateDto))
      this.getList();
      this.notificationService.show('Başarı ile güncellendi.');
    }
    this.loadingService.hide()
  }
  async deleteContact(event: any) {
    this.loadingService.show()
    await firstValueFrom(this.definationService.deleteContact(event.key))
    this.getList();
    this.notificationService.show('Başarı ile silindi.');
    this.loadingService.hide()
  }

  async createSmsAccount(event: any) {
    this.loadingService.show()
    var smsAccountCreateDto: SmsAccountCreateDto = {
      name: event.data.name,
      smsService: event.data.smsService,
      userName: event.data.userName,
      password: event.data.password,
      gsmNumber: event.data.gsmNumber,
      originator: event.data.originator
    }
    await firstValueFrom(this.definationService.createSmsAccount(smsAccountCreateDto))
    this.getList();
    this.notificationService.show('Başarı ile kaydedildi.');
    this.loadingService.hide()
  }
  async updateSmsAccount(event: any) {
    this.loadingService.show()
    if (event.newData) {
      var smsAccountUpdateDto: SmsAccountUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        smsService: event.newData.smsService ?? event.oldData.smsService,
        userName: event.newData.userName ?? event.oldData.userName,
        password: event.newData.password ?? event.oldData.password,
        gsmNumber: event.newData.gsmNumber ?? event.oldData.gsmNumber,
        originator: event.newData.originator ?? event.oldData.originator
      }
      await firstValueFrom(this.definationService.updateSmsAccount(smsAccountUpdateDto.id, smsAccountUpdateDto))
      this.getList();
      this.notificationService.show('Başarı ile güncellendi.');
    }
    this.loadingService.hide()
  }
  async deleteSmsAccount(event: any) {
    this.loadingService.show()
    await firstValueFrom(this.definationService.deleteSmsAccount(event.key))
    this.getList();
    this.notificationService.show('Başarı ile silindi.');
    this.loadingService.hide()
  }

  async createSmsTemplate(event: any) {
    this.loadingService.show()
    var smsTemplateCreateDto: SmsTemplateCreateDto = {
      name: event.data.name,
      body: event.data.body,
      replacedValues: event.data.replacedValues
    }
    await firstValueFrom(this.definationService.createSmsTemplate(smsTemplateCreateDto))
    this.getList();
    this.notificationService.show('Başarı ile kaydedildi');
    this.loadingService.hide()
  }
  async updateSmsTemplate(event: any) {
    this.loadingService.show()
    if (event.newData) {
      var smsTemplateUpdateDto: SmsTemplateUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        body: event.newData.body ?? event.oldData.body,
        replacedValues: event.newData.replacedValues ?? event.oldData.replacedValues,
      }
       await firstValueFrom(this.definationService.updateSmsTemplate(smsTemplateUpdateDto.id, smsTemplateUpdateDto))
       this.getList();
       this.notificationService.show('Başarı ile güncellendi');
    }
    this.loadingService.hide()
  }
  async deleteSmsTemplate(event: any) {
    this.loadingService.show()
    await firstValueFrom(this.definationService.deleteSmsTemplate(event.key))
    this.getList();
    this.notificationService.show('Başarı ile silindi');
    this.loadingService.hide()
  }

  async createSmtp(event: any) {
    this.loadingService.show()
    var smtpCreateDto: SmtpCreateDto = {
      name: event.data.name,
      email: event.data.email,
      password: event.data.password,
      smtpHost: event.data.smtpHost,
      port: event.data.port,
      ssl: event.data.ssl,
      subject: event.data.subject,
      body: event.data.body,
      replacedValues: event.data.replacedValues
    }
    await firstValueFrom(this.definationService.createSmtp(smtpCreateDto))
    this.getList();
    this.notificationService.show('Başarı ile kaydedildi');
    this.loadingService.hide()
  }


  async updateSmtp(event: any) {
    this.loadingService.show()
    if (event.newData) {
      var smtpUpdateDto: SmtpUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        email: event.newData.email ?? event.oldData.email,
        password: event.newData.password ?? event.oldData.password,
        smtpHost: event.newData.smtpHost ?? event.oldData.smtpHost,
        port: event.newData.port ?? event.oldData.port,
        ssl: event.newData.ssl ?? event.oldData.ssl,
        subject: event.newData.subject ?? event.oldData.subject,
        body: event.newData.body ?? event.oldData.body,
        replacedValues: event.newData.replacedValues ?? event.oldData.replacedValues
      }
      await firstValueFrom(this.definationService.updateSmtp(smtpUpdateDto.id, smtpUpdateDto))
      this.getList();
      this.notificationService.show('Başarı ile güncellendi');
    }
    this.loadingService.hide()
  }
  async deleteSmtp(event: any) {
    this.loadingService.show()
    await firstValueFrom(this.definationService.deleteSmtp(event.key))
    this.getList();
    this.notificationService.show('Başarı ile silindi');
    this.loadingService.hide()
  }
  onInitNewRowSmtp(event:any){
    event.data.ssl = true;
  }
 
  sendTestMail = async (e: any) => {
    try {
      this.loadingService.show()
      await firstValueFrom(this.definationService.sendTestMail(e.row.data.name, e.row.data.email))
      this.notificationService.show(`Test eposta'sı ${e.row.data.email} adresine gönderildi. Eposta gelen kutunuzu ve spam kutunuzu kontrol edin.`)
    } catch (err: any) {
      console.error('error', err)
    }
    this.loadingService.hide()
  }
  getLetterCount(data:any){
    if(data.name == "SiteTitle")
      return data.description.length +' - (Max-60)'
    else if(data.name == "MetaDescription")
      return data.description.length +' - (Max-160)'
    else if(data.name == "MetaKeyword")
      return data.description.length +' - (Max-250)'
    else return ''
  }

  async getBankAccounts() {
    try {
      this.loadingService.show();
      this.bankAccounts = await this.bankService.getBankaInfo();
    } catch (error) {
      console.error('Banka bilgileri alınırken hata oluştu:', error);
      this.notificationService.showError('Banka bilgileri alınırken bir hata oluştu');
    } finally {
      this.loadingService.hide();
    }
  }

  async createBankAccount(event: any) {
    try {
      this.loadingService.show();
      const newBankAccount = new BankDto(
        '',
        event.data.bankaAdi,
        // event.data.firmaAdi,
        event.data.hesapNo,
        event.data.iban,
        event.data.subeKodu
      );
      
      const updatedAccounts = [...this.bankAccounts, newBankAccount];
      await this.bankService.saveBankaInfo(updatedAccounts);
      await this.getBankAccounts();
      this.notificationService.show('Banka hesabı başarıyla eklendi');
    } catch (error) {
      console.error('Banka hesabı eklenirken hata oluştu:', error);
      this.notificationService.showError('Banka hesabı eklenirken bir hata oluştu');
    } finally {
      this.loadingService.hide();
    }
  }

  async updateBankAccount(event: any) {
    try {
      this.loadingService.show();
      // Eski ve yeni verileri birleştir
      const updatedBankAccount = new BankDto(
        event.oldData.id,
        event.newData.bankaAdi ?? event.oldData.bankaAdi,
        //event.newData.firmaAdi ?? event.oldData.firmaAdi
        event.newData.hesapNo ?? event.oldData.hesapNo,
        event.newData.iban ?? event.oldData.iban,
        event.newData.subeKodu ?? event.oldData.subeKodu
      );
  
      const updatedAccounts = this.bankAccounts.map(account =>
        account.id === updatedBankAccount.id ? updatedBankAccount : account
      );
  
      await this.bankService.saveBankaInfo(updatedAccounts);
      await this.getBankAccounts();
      this.notificationService.show('Banka hesabı başarıyla güncellendi');
    } catch (error) {
      console.error('Banka hesabı güncellenirken hata oluştu:', error);
      this.notificationService.showError('Banka hesabı güncellenirken bir hata oluştu');
    } finally {
      this.loadingService.hide();
    }
  }

  async deleteBankAccount(event: any) {
    try {
      this.loadingService.show();
      const updatedAccounts = this.bankAccounts.filter(account => account.id !== event.key);
      await this.bankService.saveBankaInfo(updatedAccounts);
      await this.getBankAccounts();
      this.notificationService.show('Banka hesabı başarıyla silindi');
    } catch (error) {
      console.error('Banka hesabı silinirken hata oluştu:', error);
      this.notificationService.showError('Banka hesabı silinirken bir hata oluştu');
    } finally {
      this.loadingService.hide();
    }
  }
}
